/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterItemDetailGeometry } from './FilterItemDetailGeometry';
import {
    FilterItemDetailGeometryFromJSON,
    FilterItemDetailGeometryFromJSONTyped,
    FilterItemDetailGeometryToJSON,
    FilterItemDetailGeometryToJSONTyped,
} from './FilterItemDetailGeometry';

/**
 * Serializer for `FilterItem` items with the shape.
 * @export
 * @interface FilterItemDetail
 */
export interface FilterItemDetail {
    /**
     * 
     * @type {number}
     * @memberof FilterItemDetail
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof FilterItemDetail
     */
    name: string;
    /**
     * 
     * @type {FilterItemDetailGeometry}
     * @memberof FilterItemDetail
     */
    geometry: FilterItemDetailGeometry;
}

/**
 * Check if a given object implements the FilterItemDetail interface.
 */
export function instanceOfFilterItemDetail(value: object): value is FilterItemDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('geometry' in value) || value['geometry'] === undefined) return false;
    return true;
}

export function FilterItemDetailFromJSON(json: any): FilterItemDetail {
    return FilterItemDetailFromJSONTyped(json, false);
}

export function FilterItemDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterItemDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'geometry': FilterItemDetailGeometryFromJSON(json['geometry']),
    };
}

export function FilterItemDetailToJSON(json: any): FilterItemDetail {
    return FilterItemDetailToJSONTyped(json, false);
}

export function FilterItemDetailToJSONTyped(value?: Omit<FilterItemDetail, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'geometry': FilterItemDetailGeometryToJSON(value['geometry']),
    };
}

